import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateUserImage as mutationFn } from '../../pages/register/api-register'
import { useToken } from '../useToken'
import { getUserInfo } from '../../infrastructure/api-signup'

export const useUpdateUserImage = () => {
    const { _id } = useToken()
    const queryClient = useQueryClient()
    const userQueryKey = ['User', `${_id}`]

    const {
        mutate: uploadImage,
        mutateAsync: uploadImageAsync,
        isPending: isImageLoading,
        ...rest
    } = useMutation({
        mutationFn,
        onMutate: async data => {
            await queryClient.cancelQueries({ queryKey: userQueryKey })
            const snapshot = queryClient.getQueryData<TData>(userQueryKey)
            queryClient.setQueryData<TData>(userQueryKey, prev => (prev ? { ...prev, user: { ...prev.user, urlImage: data } } : prev))
            return snapshot
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: userQueryKey })
        },
    })

    return { uploadImage, uploadImageAsync, isImageLoading, ...rest }
}

type TData = Awaited<NonNullable<ReturnType<typeof getUserInfo>>>
